import t from"./StatusError.js";class r extends t{constructor(t){super(t,`receipt for transaction ${t.transactionId.toString()} contained error status ${t.status.toString()}`),this.transactionReceipt=t.transactionReceipt}}export{r as default};
//# sourceMappingURL=ReceiptStatusError.js.map
